module.exports = __webpack_public_path__ + "img/headbg-2.cad61770.png";